var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.addressClass && _vm.addressClass.iconSource)?_c('img',{staticClass:"store-logo",attrs:{"src":_vm.addressClass.iconSource,"height":"40","contain":"","alt":("logo " + (_vm.addressClass.name))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }